'use client';
import Image from 'next/image';

const Benefits = ({ heading, description, benefits }) => {
  return (
    <div>
      <section className="bg-sky-50 bg-opacity-50 py-10 lg:py-20">
        <div className="max-w-screen-xl mx-5 lg:mx-auto">
          {/* Header Section */}
          <div className="text-center mb-6 md:mb-10">
            <h2 className="font-semibold text-black my-3">{heading}</h2>
            <p className="text-base md:text-lg font-medium">{description}</p>
          </div>

          {/* Benefits Sections */}
          {benefits.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className={`grid grid-cols-1 lg:grid-cols-${row.columns} gap-4 md:gap-8 mb-4 md:mb-8 ${
                row.columns === 2 ? 'lg:px-44' : ''
              }`}
            >
              {row.items.map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-center justify-center bg-blue-900 p-5 text-white transition transform hover:scale-105 hover:bg-blue-800"
                >
                  <div className="flex items-center justify-between">
                    <Image
                      src={benefit.icon}
                      className="self-start mr-3"
                      width={50}
                      height={50}
                      alt={benefit.title}
                    />
                    <div>
                      <h6 className="font-bold mb-1">{benefit.title}</h6>
                      <p className="mb-0 text-sm">{benefit.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Benefits;
